import { postMessageToMobileApp } from 'components/app/helpers';
import { isRNWebview } from 'constants/constants';
import { POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';
import errorImgPath from 'styles/assets/error.png';

import { ErrorScreen } from './error_screen';

type Props = {
  title?: string;
  onClick?: () => void;
};

const defaultProps = {
  title: 'Doh! Something went wrong...',
  onClick: () => {
    window.location.reload();
  },
};

const Whoops = (props: Props) => {
  const { title = defaultProps.title, onClick = defaultProps.onClick } = props;

  const handleSignout = () => {
    // Reload the current page without the browser cache
    localStorage.clear();
    if (onClick) {
      onClick();
    }

    if (isRNWebview()) {
      postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.LOGOUT);
    }
  };

  return (
    <ErrorScreen>
      <div className="error-img-wrapper">
        {/* //todo-h: why aren't responsive img utilities added to the main scss? */}
        <img src={errorImgPath} className="error-img" alt="Error" />
      </div>
      <p className="sorry">{title}</p>
      <button
        data-testid="reloadPageButton"
        type="button"
        onClick={onClick}
        className="reload-button"
      >
        Reload Page
      </button>
      <p className="signout-text">
        If that doesn&apos;t work, please try{' '}
        <button
          type="button"
          data-testid="signoutButton"
          onClick={handleSignout}
          className="signout-link"
        >
          signing out
        </button>{' '}
        and back in.
      </p>
    </ErrorScreen>
  );
};

export default Whoops;
